<template>
  <v-container>
    <v-row align="center" justify="center" :style="componentStyle">
      <v-col
        v-for="(item, i) in items"
        :key="i"
        cols="12"
        sm="6"
        md="4"
        class="mx-auto"
      >
        <div class="d-flex flex-column align-center justify-center text-center">
          <v-icon style="font-size: 2.5rem;" class="mx-auto primary--text">{{
            item.icon
          }}</v-icon>
          <h2 class="primary--text" style="line-height: 100%;">
            {{ item.heading }}
          </h2>
          <p class="pa-2">{{ item.text }}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "GridLayout",

  props: {
    componentStyle: {
      type: String,
    },
  },

  data: () => ({
    items: [
      {
        icon: "mdi-lock",
        heading: "Secure",
        text:
          "Our voting pages are encrypted so your voters can enjoy complete security and privacy while voting.",
      },
      {
        icon: "mdi-account-lock",
        heading: "Flexible",
        text:
          "Choose how involved you want to be. Self-administer your vote or let us manage the voting experience.",
      },
      {
        icon: "mdi-incognito",
        heading: "Anonymous",
        text:
          "We offer the strongest possible guarantee of voter anonymity: we only track who votes, and what the vote is.",
      },
      {
        icon: "mdi-chart-arc",
        heading: "Real-time results",
        text:
          "Election results are automatically calculated and presented with beautiful charts.",
      },
      {
        icon: "mdi-face-agent",
        heading: "Voter engagement",
        text:
          "Notify voters using email or sms. Voters vote by phone, computer, or in person.",
      },
      {
        icon: "mdi-cursor-default-click",
        heading: "Simple",
        text:
          "Setup your poll in 4 simple steps - spend your time monitoring, not counting.",
      },
    ],
  }),
};
</script>
